<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>기본정보</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_3"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_2"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <ml-input
            :readonly="true"
            v-else
            class="w-full flex-1"
            v-model="form.inputA_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성일</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_5 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputA_5"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>아차사고 사례 개선 확인 카드</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">개선No.</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_1 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">재해형태</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_2 }}</p>
          <disaster-class-selector
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_2"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>관련사진</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 h-upload">
        <div class="col-span-6 upload-content">
          <div class="upload-content__title">
            개선 전 사진
          </div>
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputC_1"
            />
            <img :src="form.inputC_1.thumb" v-else class="w-full h-full" />
          </div>
        </div>
        <div class="col-span-6 upload-content">
          <div class="upload-content__title">
            개선 전 사진
          </div>
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputC_2"
            />
            <img :src="form.inputC_2.thumb" v-else class="w-full h-full" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>위험성평가(평가 후 등록부에 기록)</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12">
        <div class="col-span-6 selects-content">
          <div class="selects-content__title">
            개선 전 위험성 (5x4)
          </div>
          <div class="grid grid-cols-4 h-content">
            <div class="selects-content__item">
              <div class="item--title">위험요인</div>
              <div class="item--body">
                <p class="input-area-text" v-if="isPrint">
                  {{ form.inputD_1 }}
                </p>
                <ml-textarea
                  :readonly="board.readonly"
                  v-else
                  class="input-area"
                  placeholder="위험요인"
                  rows="3"
                  v-model="form.inputD_1"
                />
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">가능성(빈도)</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_5 }}</p>
                <vs-select
                  v-else
                  v-model="form.inputD_5"
                  autocomplete
                  class="w-full "
                  @change="handleChangeinputD_2"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in options1"
                  />
                </vs-select>
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">중대성(강도)</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_6 }}</p>
                <vs-select
                  v-else
                  v-model="form.inputD_6"
                  autocomplete
                  class="w-full"
                  @change="handleChangeinputD_2"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in options2"
                  />
                </vs-select>
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">위험성</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_2 }}</p>
                <ml-input
                  :readonly="true"
                  v-else
                  v-model="form.inputD_2"
                  class="text-select-item"
                  :class="form.inputD_2"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6 selects-content">
          <div class="selects-content__title">
            개선 후 위험성 (5x4)
          </div>
          <div class="grid grid-cols-4 h-content">
            <div class="selects-content__item">
              <div class="item--title">감소대책</div>
              <div class="item--body">
                <p class="input-area-text" v-if="isPrint">
                  {{ form.inputD_3 }}
                </p>
                <ml-textarea
                  :readonly="board.readonly"
                  v-else
                  v-model="form.inputD_3"
                  class="input-area"
                  placeholder="감소대책"
                  rows="3"
                />
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">가능성(빈도)</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_7 }}</p>
                <vs-select
                  v-else
                  v-model="form.inputD_7"
                  autocomplete
                  class="w-full"
                  @change="handleChangeinputD_4"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in options1"
                  />
                </vs-select>
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">중대성(강도)</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_8 }}</p>
                <vs-select
                  v-else
                  v-model="form.inputD_8"
                  autocomplete
                  class="w-full"
                  @change="handleChangeinputD_4"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in options2"
                  />
                </vs-select>
              </div>
            </div>
            <div class="selects-content__item">
              <div class="item--title">위험성</div>
              <div class="item--body">
                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_4 }}</p>
                <ml-input
                  :readonly="true"
                  v-else
                  v-model="form.inputD_4"
                  class="text-select-item"
                  :class="form.inputD_4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
export default {
  components: {
    DateSelector,
    DisasterClassSelector,
    FileUploadModule,
    FileUploader
  },
  name: "Write",
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 =
          this.value && this.value.inputA_1
            ? this.value.inputA_1
            : this.board.projectTitle;
        this.form.inputA_2 =
          this.value && this.value.inputA_2
            ? this.value.inputA_2
            : this.board.writer.com_name;
        this.form.inputA_4 =
          this.value && this.value.inputA_4
            ? this.value.inputA_4
            : this.board.writer.name;
        this.form.inputA_3 =
          this.value && this.value.inputA_3
            ? this.value.inputA_3
            : this.board.writer.department;
      }
    },
    value(value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        this.form[key] = value[key];
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1;
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      options1: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" }
      ],
      options2: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" }
      ],

      form: {
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",

        inputB_1: "",
        inputB_2: "",

        inputC_1: {},
        inputC_2: {},

        inputD_1: "",
        inputD_2: "F",
        inputD_3: "",
        inputD_4: "F",
        inputD_5: 1,
        inputD_6: 1,
        inputD_7: 1,
        inputD_8: 1
      }
    };
  },
  methods: {
    handleResult(result) {
      if (result >= 1 && result <= 3) return "F";
      else if (result >= 4 && result <= 6) return "E";
      else if (result === 8) return "D";
      else if (result >= 9 && result <= 12) return "C";
      else if (result === 15) return "B";
      else if (result >= 16 && result <= 20) return "A";
    },
    handleChangeinputD_2() {
      let multiplication = this.form.inputD_5 * this.form.inputD_6;
      this.form.inputD_2 = this.handleResult(multiplication);
    },
    handleChangeinputD_4() {
      let multiplication = this.form.inputD_7 * this.form.inputD_8;
      this.form.inputD_4 = this.handleResult(multiplication);
    }
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */

.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
}
/* selects */
.text-select-item {
  color: #e42728;
  &.E { color: #ff8510 }
  &.F { color: #28c76f }
}
input.vs-inputx.vs-input--input.normal.hasValue {
  font-weight: 700;
  color: blueviolet !important;
}
.selects-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__item {
    border-left: $border;
    &:first-child {
      border-left: none;
    }
    .item--title {
      height: 54px;
      line-height: 54px;
      text-align: center;
      background: #fafafa;
      border-bottom: $border;
    }
    .item--body {
      padding: 7px;
      height: calc(100% - 54px);
      display: flex;
      justify-content: center;
      .input-area {
        border: 1px solid #cdcdcd;
        border-radius: 5px;
        margin: 0;
      }
      .input-area-text {
        margin: 0;
        height: 85px;
        width: 100%;
        padding: 5px;
      }
    }
  }
  .h-content {
    height: calc(100% - 54px);
  }
}
</style>
